export const usePageTitle = () => {
    return {
        append: (title: string) =>
            useHead({
                titleTemplate: (suffix) => `${title} | ${suffix}`,
            }),
    };
};
